
<div class="clickable-header" [style.min-width.em]="minWidth">
  <button class="button is-small is-white btn-sort" (click)="toggleSort()" tabindex="0" data-ui-name="Toggle Sort" data-ui-component="table-header" data-testid="table-header-toggle-sort">
    <span class="is-header-text" [class.is-wrap-disabled]="disableCaptionWrap" [ngStyle]="{'color': color}">
      <tra [slug]="caption"></tra>
    </span>
    <span class="sorting-indicator" [ngSwitch]="getSortType()">
      <span *ngSwitchCase="SortMode.DESC"><i class="fa fa-caret-down" aria-hidden="true"></i></span>
      <span *ngSwitchCase="SortMode.ASC"><i class="fa fa-caret-up" aria-hidden="true"></i></span>
    </span>
  </button>
  <button *ngIf="!disableFilter" class="button is-small is-light btn-filter" (click)="toggleFilter()" tabindex="0" data-ui-name="Toggle Filter" data-ui-component="table-header" data-testid="table-header-toggle-filter">
    <i class="fa fa-filter" aria-hidden="true"></i>
  </button>
</div>
<div class="filter-settings" *ngIf="isFilterActive">
  <div *ngIf="customFilter;else defaultFilter">
    <custom-column-filter
      [id]="id"
      [filter]="customFilter"
      [ctrl]="ctrl"
     data-ui-name="Custom column filter" data-ui-component="table-header" data-testid="table-header-custom-column-filter"></custom-column-filter>
  </div>
  <ng-template #defaultFilter>
    <capture-filter-range
      [id]="id"
      [isActive]="true"
      [model]="getFilterModel()"
      (change)="updateFilter()"
     data-ui-name="Capture filter range" data-ui-component="table-header" data-testid="table-header-capture-filter-range"></capture-filter-range>
  </ng-template>
</div>
